import { combineReducers } from 'redux'
import userReducer from './user/user.reducer'
import businessReducer from './business/business.reducer'
import businessLocationReducer from './business-location/businessLocation.reducer'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import employeeReducer from './employee/employee.reducer'
import projectReducer from './project/project.reducer'
import shiftReducer from './shift/shift.reducer'
import taskReducer from './task/task.reducer'
import chatReducer from './chat/chat.reducer'
import requestReducer from './request/request.reducer'
import documentReducer from './document/document.reducer'
import policyReducer from './policy/policy.reducer'
import contactUsReducer from './contact-us/contactUs.reducer'
import subscriptionReducer from './subscription/subscription.reducer'
import assetReducer from './asset/asset.reducer'
import peformanceReducer from './performance/peformance.reducer'
import auditReducer from './audit/audit.reducer'
import visitorReducer from './visitor/visitor.reducer'
import payrollReducer from './payroll/payroll.reducer'
import merchantReducer from './merchant/merchant.reducer'
import suppliesReducer from './supplies/supplies.reducer'

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['user']
}

const rootReducer = combineReducers({
    user: userReducer,
    business: businessReducer,
    businessLocation: businessLocationReducer,
    employee: employeeReducer,
    project: projectReducer,
    shift: shiftReducer,
    task: taskReducer,
    chat: chatReducer,
    request: requestReducer,
    document: documentReducer,
    policy: policyReducer,
    contactUs: contactUsReducer,
    subscription: subscriptionReducer,
    asset: assetReducer,
    peformance: peformanceReducer,
    audit: auditReducer,
    visitor: visitorReducer,
    payroll: payrollReducer,
    merchant: merchantReducer,
    supplies: suppliesReducer
})

// export default rootReducer
export default persistReducer(persistConfig, rootReducer)